import * as Models from 'contracts/models';

export const Endpoint = ({ contextId }: Payload) => `/vscanner/api/v2/projects/logs/${contextId}`;

export const QueryKey = ({ contextId, cursor = 0 }: Payload) =>
    ['vscanner', 'api', 'v2', 'projects', 'logs', contextId, cursor] as const;

export type Payload = {
    contextId: string;
    cursor?: number;
};

export type Response = {
    cursor: number;
    log: Models.Vscanner.ProjectTaskLogMessage[];
};
